import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, limit } from "../comman/config";
import Select from "react-select";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { useNavigate, Link } from "react-router-dom";
import { EventDateSessionFilter } from "../components/Filter/EventDateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';
import { methodInList, pickMethod } from '../comman/methods';
// import Pagination from "react-js-pagination";

function RawMaterialEstimation() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [methodList, setMethodList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [date, setDate] = useState(today);
  const [session, setSession] = useState("");
  const [formData, setFormData] = useState([]);
  const [detail, setDetail] = useState([]);
  const [transformedData, setTransformedData] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [validationAllErrors, setValidationAllErrors] = useState([]);
  const [mealItemArray, setMealItemArray] = useState([]);
  const role = localStorage.getItem('userRole');
  const [loading, setLoading] = useState(false)
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [aggregatedMealList, setAggregatedMealList] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [eventId, setEventId] = useState(null);


  useEffect(() => {
    // Create initial formData and validationErrors based on mealList length
    const initialFormData = mealList.map(() => ({
      default_method: "",
      estimated_count: "",
      rm_to_fg_ratio: "",
      ras_qty_per_100_person: "",
      std_ras_qty_per_100_person:"",
      estimated_finished_goods: "",
      estimated_rm_required: "",
      fg_consumption_per_person: "",
      planned_rm_qty: "",
      estimated_production: "",
    }));
    setFormData(initialFormData);

    const initialValidationErrors = mealList.map(() => ({
      estimated_count: false,
      planned_rm_qty: false,
      estimated_production: false,
    }));
    setValidationErrors(initialValidationErrors);
  }, [mealList]);
  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      getMethodList();
    }
  }, [mealList, activeIndex]);

  useEffect(() => {
    if (mealList.length > 0 && methodList.length > 0 && activeIndex != null) {
      const itemId =
        mealList.find((item, index) => index === activeIndex).menu_item_id ??
        null;
      const fetchDetail = async () => {
        setLoading(true)
        const condition = `menu_item_id='${itemId}' AND from_date = '${fromDate}' AND to_date = '${toDate}' AND session_id='${session[0].value}'`;
        const response = await axios.get(
          `${baseUrl}/comman/list?table=raw_material_summary&condition=${condition}`,
          { headers: { 'Cache-Control': 'no-cache' } }
        );
        setDetail(response.data.data);
        const apiDetail = response.data.data[0];
        getDetailDispaly(apiDetail, itemId);
        setLoading(false)
      };
      fetchDetail();
    }
  }, [mealList, methodList, activeIndex]);

    // useEffect(() => {
  //   const fetchData = async () => {
  //     if (aggregatedMealList.length > 0) {
  //       setLoading(true)
  //       const data = [];

  //       for (const [index, item] of aggregatedMealList.entries()) {
  //         const itemId = item.menu_item_id;
  //          //m.session='${session[0].value}' AND m.date BETWEEN '${fromDate}' AND '${toDate}'
  //         //const condition = `menu_item_id='${itemId}' AND date BETWEEN '${fromDate}' AND '${toDate}' AND session='${session[0].value}'`;
  //         const condition = `menu_item_id='${itemId}' AND from_date ='${fromDate}' AND to_date='${toDate}' AND session_id='${session[0].value}'`;
  //         const detailResponse = await axios.get(`${baseUrl}/comman/list?table=raw_material_summary&condition=${condition}`);
  //         const apiDetail = detailResponse.data.data[0];
  //         // console.log("api detail:",apiDetail)
  //         const frezzCondition = `menu_item_id='${itemId}' AND date BETWEEN '${fromDate}' AND '${toDate}' AND session='${session[0].value}'`;
  //         const checkFrezz = await axios.get(`${baseUrl}/comman/list?table=production_receipe_planning&condition=${frezzCondition}`);
  //         //const itemDisable = checkFrezz.data.data.length > 0 ? true : false;
  //         const itemDisable = false;
          
  //         if (item && item.menu_item_id) {
  //         const result = await getTableDetailDispaly(apiDetail, itemId, item, index, aggregatedMealList, itemDisable);
  //         if (result) {
  //         data.push(result);
  //         }
  //       }
  //       };

  //       setTransformedData(data);
  //       setLoading(false)
  //     }
  //   };
  //   fetchData();
  // }, [aggregatedMealList]);
  useEffect(() => {
    fetchData();
  }, [aggregatedMealList, baseUrl, fromDate, toDate, session]);  // Check for changes when component mounts or key dependencies change

  const fetchData = async () => {
    if (aggregatedMealList.length === 0) return;
    setLoading(true);

    const sessionId = session[0]?.value;
    const validItems = aggregatedMealList.filter(item => item.menu_item_id);

    try {
      // Phase 1: raw_material_summary for all items — 1 request
      const p1Queries = validItems.map(item => ({
        key: `rms_${item.menu_item_id}`,
        table: 'raw_material_summary',
        condition: `menu_item_id='${item.menu_item_id}' AND from_date='${fromDate}' AND to_date='${toDate}' AND session_id='${sessionId}'`,
      }));
      const p1 = p1Queries.length > 0
        ? (await axios.post(`${baseUrl}/comman/batch-list`, { queries: p1Queries })).data.data
        : {};

      // Phase 2: item_master for all items (to get method IDs) — 1 request
      const p2Queries = validItems.map(item => ({
        key: `im_${item.menu_item_id}`,
        table: 'item_master',
        condition: `id=${item.menu_item_id}`,
      }));
      const p2 = p2Queries.length > 0
        ? (await axios.post(`${baseUrl}/comman/batch-list`, { queries: p2Queries })).data.data
        : {};

      // Phase 3: consumption_master + method_master (depends on method from phase 2) — 1 request
      const p3Queries = validItems.flatMap(item => {
        const method = p2[`im_${item.menu_item_id}`]?.[0]?.method ?? null;
        if (!method) return [];
        return [
          { key: `cm_${item.menu_item_id}`, table: 'consumption_master', condition: `menu_item_id='${item.menu_item_id}' AND method IN (${methodInList(method)})` },
          { key: `mm_${item.menu_item_id}`, table: 'method_master',      condition: `id IN (${methodInList(method)})` },
        ];
      });
      const p3 = p3Queries.length > 0
        ? (await axios.post(`${baseUrl}/comman/batch-list`, { queries: p3Queries })).data.data
        : {};

      const results = aggregatedMealList.map((item, index) => {
        const itemId = item.menu_item_id;
        if (!itemId) return null;

        const apiDetail          = p1[`rms_${itemId}`]?.[0] ?? null;
        const { methodId, consumption: consumptionResponse } = pickMethod(p2[`im_${itemId}`]?.[0]?.method, p3[`cm_${itemId}`]);
        const methodName         = p3[`mm_${itemId}`]?.find(m => m.id === methodId)?.name ?? '';
        const sessionCount       = apiDetail?.session_count || item.sessionCount || 1;

        if (apiDetail) {
          const estimated_count    = apiDetail?.estimated_count || item.estimated_count || 0;
          const totalPlannedCount  = apiDetail?.total_planned_count || (estimated_count * sessionCount);
          return {
            item_name:                    aggregatedMealList[index].item_name,
            eng_name:                     aggregatedMealList[index].eng_name,
            menu_item_id:                 aggregatedMealList[index].menu_item_id,
            estimated_count,
            std_ras_qty_per_100_person:   apiDetail.std_ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0,
            ras_qty_per_100_person:       apiDetail.ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0,
            estimated_rm_required:        apiDetail.estimated_rm_required || ((estimated_count * (apiDetail.ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0)) / 100).toFixed(2),
            planned_rm_qty:               apiDetail.planned_rm_qty || 0,
            rm_to_fg_ratio:               apiDetail.rm_to_fg_ratio || consumptionResponse?.rm_to_fg_ratio || 0,
            estimated_finished_goods:     apiDetail.estimated_finished_goods || 0,
            fg_consumption_per_person:    apiDetail.fg_consumption_per_person || consumptionResponse?.fg_consumption_per_person || 0,
            estimated_production:         apiDetail.estimated_production || 0,
            remarks:                      apiDetail.remarks || '',
            db_id:                        apiDetail.id,
            itemDisable:                  (role == 0 || role == 1) ? false : false,
            unit:                         methodName,
            sessionCount,
            totalPlannedCount,
          };
        } else {
          const estimated_count   = item.estimated_count ?? 0;
          const totalPlannedCount = estimated_count * sessionCount;
          const ras_qty_per_100_person = item.ras_qty_per_100_person || (consumptionResponse?.ras_raw_mat_per_100_person ?? 0);
          return {
            item_name:                    aggregatedMealList[index].item_name,
            eng_name:                     aggregatedMealList[index].eng_name,
            menu_item_id:                 aggregatedMealList[index].menu_item_id,
            estimated_count,
            std_ras_qty_per_100_person:   consumptionResponse?.ras_raw_mat_per_100_person ?? 0,
            ras_qty_per_100_person,
            estimated_rm_required:        ((totalPlannedCount * ras_qty_per_100_person) / 100).toFixed(2),
            planned_rm_qty:               item.planned_rm_qty ?? 0,
            rm_to_fg_ratio:               consumptionResponse?.rm_to_fg_ratio ?? 0,
            estimated_finished_goods:     '',
            fg_consumption_per_person:    consumptionResponse?.fg_consumption_per_person ?? 0,
            estimated_production:         '',
            itemDisable:                  (role == 0 || role == 1) ? false : false,
            remarks:                      '',
            sessionCount,
            totalPlannedCount,
          };
        }
      });

      setTransformedData(results.filter(Boolean));
    } catch (err) {
      console.error('Error in fetchData:', err);
    } finally {
      setLoading(false);
    }
  };
  const getDetailDispaly = async (detail, itemId) => {
    try {
      if (detail) {
        const methodItem = methodList.find(
          (item) => item.id == detail.default_method
        );
        const methodObject = methodItem
          ? { value: methodItem.id, label: methodItem.name }
          : { value: "", label: "" };
        const newState = {
          default_method: methodObject,
          estimated_count: detail?.estimated_count || 0,
          rm_to_fg_ratio: detail?.rm_to_fg_ratio || 0,
          ras_qty_per_100_person: detail?.ras_qty_per_100_person || 0,
          std_ras_qty_per_100_person : detail?.std_ras_qty_per_100_person || 0,
          estimated_finished_goods: detail?.estimated_finished_goods || 0,
          estimated_rm_required: detail?.estimated_rm_required || 0,
          fg_consumption_per_person: detail?.fg_consumption_per_person || 0,
          planned_rm_qty: detail?.planned_rm_qty || 0,
          estimated_production: detail?.estimated_production || 0,
          remarks : detail?.remarks || ""
        };
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[activeIndex] = {
            ...updatedFormData[activeIndex],
            ...newState,
          };
          return updatedFormData;
        });
      } else {
        const response = await axios.get(
          `${baseUrl}/comman/list?table=item_master&condition=id=${itemId}`,
          { headers: { 'Cache-Control': 'no-cache' } }
        );
        const itemMethod = response.data?.data[0]?.method ?? null;

        const consumptionApiCall = await axios.get(
          `${baseUrl}/comman/list?table=consumption_master&condition=menu_item_id='${itemId}' AND method IN (${methodInList(itemMethod)})`
        );
        const { methodId: itemMethodId, consumption: consumptionResponse } = pickMethod(itemMethod, consumptionApiCall.data.data);

        const methodItem = methodList.find((item) => item.id == itemMethodId);
        const methodObject = methodItem
          ? { value: methodItem.id, label: methodItem.name }
          : { value: "", label: "" };
        const newState = {
          ...formData[activeIndex],
          default_method: methodObject,
          rm_to_fg_ratio: consumptionResponse?.rm_to_fg_ratio || 0,
          fg_consumption_per_person:
            consumptionResponse?.fg_consumption_per_person || 0,
          ras_qty_per_100_person:
            consumptionResponse?.ras_raw_mat_per_100_person || 0,
          std_ras_qty_per_100_person:
            consumptionResponse?.ras_raw_mat_per_100_person || 0,
        };
        setFormData((prevFormData) => {
          const updatedFormData = [...prevFormData];
          updatedFormData[activeIndex] = {
            ...updatedFormData[activeIndex],
            ...newState,
          };
          return updatedFormData;
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };

  const handelFilterChange = async (fromDate, toDate, session, eventId) => {
    //setDate(fromDate);
    setFromDate(fromDate);
    setToDate(toDate);
    setSession(session);
    setEventId(eventId);
    
    if (fromDate && toDate && session) {
      const condition = ` m.session='${session[0].value}' AND m.date BETWEEN '${fromDate}' AND '${toDate}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/session_count?condition=${condition}`
      );
      const result = response.data.data;
      console.log("result:",result);

      // Save the original meal list for reference
      setMealList(result);
      
      // Save the aggregated meal list for display
      setAggregatedMealList(result);

      const extractedObject = {
        "date": result[0]?.date,
        "session": result[0]?.session,
        "item_name": result[0]?.item_name,
        "eng_name": result[0]?.eng_name,
        "menu_item_id": result[0]?.menu_item_id,
        "id": result[0]?.id
    };
    
      setMealItemArray([extractedObject]);
      //setMealList(result);
    // }
}
  };

  const validation = (index, type) => {
    let newValidationErrors = {
      estimated_count: formData[index].estimated_count === "",
      planned_rm_qty: formData[index].planned_rm_qty === "",
    };
    if (type === "save") {
      newValidationErrors.estimated_production =
        formData[index].estimated_production === "";
    }
    
    setValidationErrors((prevValidationErrors) => {
      const updatedValidationErrors = [...prevValidationErrors];
      updatedValidationErrors[index] = { ...newValidationErrors };
      return updatedValidationErrors;
    });
    return Object.values(newValidationErrors).some((error) => error);
  };

  const validationAll = ( type) => {
    const newValidationErrors = transformedData.map((entry, index) => {
      let errors = {
        estimated_count: entry.estimated_count === "",
        planned_rm_qty: entry.planned_rm_qty === "",
      };
  
      if (type === "save") {
        errors.estimated_production = entry.estimated_production === "";
      }
  
      return errors;
    });
  
    setValidationAllErrors(newValidationErrors);
  
    // Return true if any entry has validation errors
    return newValidationErrors.some((errors) =>
      Object.values(errors).some((error) => error)
    );
   
  };
  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    // setFormData((prevFormData) => {
    //   const updatedFormData = [...prevFormData];
    //   updatedFormData[index] = { ...updatedFormData[index], [name]: value };
    //   return updatedFormData;
    // });
    console.log("value:",value);
    setTransformedData((prevFormData) => {
      const updatedFormData = [...prevFormData];
      console.log("updated form data:",updatedFormData);
      updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      return updatedFormData;
    });


    setValidationErrors((prevValidationErrors) => {
      const updatedValidationErrors = [...prevValidationErrors];
      updatedValidationErrors[index] = {
        ...updatedValidationErrors[index],
        [name]: false,
      };
      return updatedValidationErrors;
    });
  };

  const handleCalculate = (e, index) => {
    e.preventDefault();
    const planned_rm_qty = formData[index].planned_rm_qty ?? 0;
    const rm_to_fg_ratio = formData[index].rm_to_fg_ratio;
    const fg_consumption_per_person = formData[index].fg_consumption_per_person;
    const estimated_count = formData[index].estimated_count ?? 0;
    const ras_qty_per_100_person = formData[index].ras_qty_per_100_person;

    const estimated_finished_goods = (
      planned_rm_qty * rm_to_fg_ratio ?? 0
    ).toFixed(2);
    const estimated_production =
      fg_consumption_per_person != "" && fg_consumption_per_person != 0
        ? (estimated_finished_goods / fg_consumption_per_person).toFixed(2) ?? 0
        : 0;
    const estimated_rm_required =
      ras_qty_per_100_person != ""
        ? ((estimated_count * ras_qty_per_100_person) / 100).toFixed(2) ?? 0
        : 0;

    const newState = {
      ...formData[activeIndex],
      estimated_finished_goods: estimated_finished_goods,
      estimated_production: estimated_production,
      estimated_rm_required: estimated_rm_required,
    };
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[activeIndex] = {
        ...updatedFormData[activeIndex],
        ...newState,
      };
      return updatedFormData;
    });
    // }
  };

  const handleCalculateAll = async(e, idx) => {
    e.preventDefault();
    const inputName = e.target.name;
    const data = await Promise.all(mealList.map(async (item, index) => {
      if(index === idx){
      const planned_rm_qty = transformedData[index].planned_rm_qty ?? 0;
      const rm_to_fg_ratio = transformedData[index].rm_to_fg_ratio;
      const fg_consumption_per_person = transformedData[index].fg_consumption_per_person;
      const estimated_count = transformedData[index].estimated_count ?? 0;
      
      const sessionCount = transformedData[index].sessionCount ?? 1;
      // const ras_qty_per_100_person = planned_rm_qty && estimated_count
      //   ? ((planned_rm_qty * 100) / estimated_count).toFixed(2)
      //   : transformedData[index].ras_qty_per_100_person;
      // Only recalculate if user didn't manually enter ras_qty_per_100_person
      const ras_qty_per_100_person = inputName === 'ras_qty_per_100_person' 
        ? (Number(transformedData[index].ras_qty_per_100_person).toFixed(2)) // Keep manual value
        : (planned_rm_qty && estimated_count
            ? ((planned_rm_qty * 100) / estimated_count).toFixed(2)
            : (Number(transformedData[index].std_ras_qty_per_100_person)).toFixed(2));
      const totalPlannedCount = estimated_count * sessionCount;
      // Updated calculation for estimated_rm_required
      const estimated_rm_required = ras_qty_per_100_person != "" 
      ? ((estimated_count * ras_qty_per_100_person) / 100).toFixed(2) ?? 0 
      : 0;
      //const estimated_rm_required = ras_qty_per_100_person != "" ? ((estimated_count * ras_qty_per_100_person) / 100).toFixed(2) ?? 0 : 0;
      const estimated_finished_goods = (planned_rm_qty * rm_to_fg_ratio ?? 0).toFixed(2);
      const estimated_production = fg_consumption_per_person != "" && fg_consumption_per_person != 0 ? (estimated_finished_goods / fg_consumption_per_person).toFixed(2) ?? 0 : 0;

      const newState = {
        ...transformedData[index],
        ras_qty_per_100_person: ras_qty_per_100_person,
        planned_rm_qty: planned_rm_qty,
        estimated_finished_goods: estimated_finished_goods,
        estimated_production: estimated_production,
        estimated_rm_required: estimated_rm_required,
        totalPlannedCount: totalPlannedCount,
      };
      return newState;
    }else{
      const newState = {
        ...transformedData[index]
      };
      return newState;
    }
    }));

    setTransformedData(data)
  
  }

  const handleSave = async (e, index) => {
    e.preventDefault();

    const hasErrors = validation(index, "save");
    if (!hasErrors) {
      const menu_item_id =
      transformedData.find((item, i) => i == index)?.menu_item_id ?? 0;
      const combineData = {
        formData: transformedData[index],
        date: fromDate,
        toDate: toDate,
        session: session,
        menu_item_id: menu_item_id,
      };
      // console.log(combineData);
      try {
        // setPopupOpen(true);
        let url;
        if (detail.length > 0) {
          url = `raw_material/edit/${detail[0].id}`;
        } else {
          url = "raw_material/session_add";
        }
        await axios.post(`${baseUrl}/${url}`, combineData);
        toast.success("Data successfully saved!");
        // Re-fetch detail so subsequent saves route to /edit/:id instead of /session_add
        // (otherwise the next click would INSERT a duplicate row).
        await refreshCurrentData();
      } catch (error) {
        toast.error("Failed to submit the form.");
        console.log(error);
      }
    }
  };

  const handleSaveAll = async (e) => {
    e.preventDefault();
    const hasErrors = validationAll("save");
    if (!hasErrors) {
      let idx = [];
      const data = await Promise.all(transformedData.map(async(item, index) => {
        const menu_item_id = item.menu_item_id;
        const combineData = {
          formData: {
            item_name: item.item_name,
            eng_name: item.eng_name,
            estimated_count: item.estimated_count,
            sessionCount: item.sessionCount,
            totalPlannedCount: item.totalPlannedCount,
            std_ras_qty_per_100_person: item.std_ras_qty_per_100_person,
            ras_qty_per_100_person: item.ras_qty_per_100_person,
            estimated_rm_required: item.estimated_rm_required,
            planned_rm_qty: item.planned_rm_qty,
            rm_to_fg_ratio: item.rm_to_fg_ratio,
            estimated_finished_goods: item.estimated_finished_goods,
            fg_consumption_per_person: item.fg_consumption_per_person,
            estimated_production: item.estimated_production,
            unit: item.unit,
            remarks: item.remarks
          },
          date: fromDate,
          toDate: toDate,
          session: session,
          menu_item_id: menu_item_id,
        };
        try {
          let url;
          if (item.db_id > 0) {
            url = `raw_material/summaray_edit/${item.db_id}`;
          } else {
            url = "raw_material/summary_add";
          }
          await axios.post(`${baseUrl}/${url}`, combineData);
          idx.push(index + 1);
        } catch (error) {
          toast.error("Failed to submit the form.");
          console.log(error);
        }
      }));
      if(idx.length == transformedData.length){
        toast.success("Data successfully saved!");

        refreshCurrentData();
        // window.location.reload();
      } else {
        toast.error("Failed to submit the form.");
      }
    }
  }

  const refreshCurrentData = async () => {
    try {
      setLoading(true);
      
      // Refresh all the meal items data with their updated values
      if (mealList.length > 0 && methodList.length > 0) {
        // If there's an active item, refresh its details
        if (activeIndex !== null) {
          const itemId = mealList.find((item, index) => index === activeIndex).menu_item_id ?? null;
          const condition = `menu_item_id='${itemId}' AND from_date = '${fromDate}' AND to_date = '${toDate}' AND session_id='${session[0].value}'`;
          
          const response = await axios.get(
            `${baseUrl}/comman/list?table=raw_material_summary&condition=${condition}`,
            { headers: { 'Cache-Control': 'no-cache' } }
          );
          
          setDetail(response.data.data);
          const apiDetail = response.data.data[0];
          getDetailDispaly(apiDetail, itemId);
        }
      }
      
      setLoading(false);
    } catch (error) {
      console.error("Error refreshing data:", error);
      toast.error("Saved successfully but failed to refresh data.");
      setLoading(false);
    }
  };

  const handleRefresh = async (e) => {
    e.preventDefault();
    const itemId =
      mealList.find((item, index) => index === activeIndex).menu_item_id ??
      null;
    getDetailDispaly("", itemId);
  };

  const handleRefreshAll = async (e, idx) => {
    e.preventDefault()
    const data = await Promise.all(transformedData.map(async (item, index) => {
      if(idx == index){

      
      const itemId = transformedData[index].menu_item_id;
      const response = await axios.get(
        `${baseUrl}/comman/list?table=item_master&condition=id=${itemId}`
      );
      const itemMethod = response.data?.data[0]?.method ?? null;
      const consumptionApiCall = await axios.get(
        `${baseUrl}/comman/list?table=consumption_master&condition=menu_item_id='${itemId}' AND method IN (${methodInList(itemMethod)})`
      );
      const { consumption: consumptionResponse } = pickMethod(itemMethod, consumptionApiCall.data.data);
      const newState = {
        ...transformedData[index],
        rm_to_fg_ratio: consumptionResponse?.rm_to_fg_ratio || 0,
        fg_consumption_per_person:
          consumptionResponse?.fg_consumption_per_person || 0,
        ras_qty_per_100_person:
          consumptionResponse?.ras_raw_mat_per_100_person || 0,
        std_ras_qty_per_100_person:
          consumptionResponse?.ras_raw_mat_per_100_person || 0,
      };
      return newState;
    }else{
      return {
        ...transformedData[index]
      }
    }
    }));
    
    setTransformedData(data);
  
  }

  const getTableDetailDispaly = async(apiDetail, itemId, item, index, mealList, itemDisable) => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=item_master&condition=id=${itemId}`
    );
    const itemMethod = response.data?.data[0]?.method ?? null;
    const [consumptionApiCall, method] = await Promise.all([
      axios.get(`${baseUrl}/comman/list?table=consumption_master&condition=menu_item_id='${itemId}' AND method IN (${methodInList(itemMethod)})`),
      axios.get(`${baseUrl}/comman/list?table=method_master&condition=id IN (${methodInList(itemMethod)})`),
    ]);
    const { methodId, consumption: consumptionResponse } = pickMethod(itemMethod, consumptionApiCall.data.data);
    const methodName = method.data.data.find(m => m.id === methodId)?.name ?? '';
    
    // Use saved session count if available, otherwise default to item's value or 1
    const sessionCount = apiDetail?.session_count || item.sessionCount || 1;
  
    if(apiDetail){
      const estimated_count = apiDetail?.estimated_count || item.estimated_count || 0;
      const totalPlannedCount = apiDetail?.total_planned_count || (estimated_count * sessionCount);
      
      const newState = {
        item_name: mealList[index].item_name,
        eng_name: mealList[index].eng_name,
        menu_item_id: mealList[index].menu_item_id,
        estimated_count: estimated_count,
        std_ras_qty_per_100_person: apiDetail.std_ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0,        
        ras_qty_per_100_person: apiDetail.ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0,
        estimated_rm_required: apiDetail.estimated_rm_required || ((estimated_count * (apiDetail.ras_qty_per_100_person || consumptionResponse?.ras_raw_mat_per_100_person || 0)) / 100).toFixed(2),
        planned_rm_qty: apiDetail.planned_rm_qty || 0,
        rm_to_fg_ratio: apiDetail.rm_to_fg_ratio || consumptionResponse?.rm_to_fg_ratio || 0,
        estimated_finished_goods: apiDetail.estimated_finished_goods || 0,
        fg_consumption_per_person: apiDetail.fg_consumption_per_person || consumptionResponse?.fg_consumption_per_person || 0,
        estimated_production: apiDetail.estimated_production || 0,
        remarks: apiDetail.remarks || "",
        db_id: apiDetail.id,
        itemDisable: (role == 0 || role == 1) ? false : itemDisable,
        unit: methodName,
        sessionCount: sessionCount,
        totalPlannedCount: totalPlannedCount
      };
      return newState;
    } else {
      // Your existing code for when there's no saved data
      const estimated_count = item.estimated_count ?? 0;
      const totalPlannedCount = estimated_count * sessionCount;
  
      const ras_qty_per_100_person = item.ras_qty_per_100_person ? item.ras_qty_per_100_person : consumptionResponse?.ras_raw_mat_per_100_person ?? 0;
      const ob = {
        item_name: mealList[index].item_name,
        eng_name: mealList[index].eng_name,
        menu_item_id: mealList[index].menu_item_id,
        estimated_count: item.estimated_count ?? 0,
        std_ras_qty_per_100_person: consumptionResponse?.ras_raw_mat_per_100_person ?? 0,
        ras_qty_per_100_person: ras_qty_per_100_person,
        estimated_rm_required: ((totalPlannedCount * ras_qty_per_100_person) / 100).toFixed(2),
        planned_rm_qty: item.planned_rm_qty ?? 0,
        rm_to_fg_ratio: consumptionResponse?.rm_to_fg_ratio ?? 0,
        estimated_finished_goods: "",
        fg_consumption_per_person: consumptionResponse?.fg_consumption_per_person ?? 0,
        estimated_production: "",
        itemDisable: (role == 0 || role == 1) ? false : itemDisable,
        remarks: "",
        sessionCount: sessionCount,
        totalPlannedCount: totalPlannedCount
      };
      return ob;
    }
  }

  const handelAllEstimateCount = (e) => {
    e.preventDefault();
    const estimated_count = e.target.value;
    if(estimated_count){
      const updatedArray = transformedData.map(obj => {
        console.log("transform data1:",transformedData);
        if (obj.itemDisable === false) {
          // Set the count value for items where itemDisable is false
          const planned_rm_qty = obj.planned_rm_qty ?? 0;
          const rm_to_fg_ratio = obj.rm_to_fg_ratio;
          const fg_consumption_per_person = obj.fg_consumption_per_person;
          const ras_qty_per_100_person = obj.ras_qty_per_100_person;
          const sessionCount = obj.sessionCount || 1;
          const totalPlannedCount = estimated_count * sessionCount;

          const estimated_rm_required = ras_qty_per_100_person != "" 
            ? ((totalPlannedCount * ras_qty_per_100_person) / 100).toFixed(2) ?? 0 
            : 0;
          const estimated_finished_goods = (planned_rm_qty * rm_to_fg_ratio ?? 0).toFixed(2);
          const estimated_production = fg_consumption_per_person != "" && fg_consumption_per_person != 0 ? (estimated_finished_goods / fg_consumption_per_person).toFixed(2) ?? 0 : 0;
  
  
          return {
            ...obj,
            estimated_count: estimated_count,
            totalPlannedCount: totalPlannedCount,
            estimated_finished_goods: estimated_finished_goods,
            estimated_production: estimated_production,
            estimated_rm_required: estimated_rm_required,
          };
        } else {
          // Keep the original object if itemDisable is true
          return obj;
        }
      });
      
      setTransformedData(updatedArray);
    }
  }

//   // Function to detect and handle menu changes
const checkAndUpdateMenuChanges = async () => {
  const sessionId = session[0]?.value;
    if (!eventId) return;
    setLoading(true)
    setIsUpdating(true);
    
    try {
        // First, detect what changes have occurred
        const detectResponse = await axios.post(`${baseUrl}/event_count/detect-change`, {
            event_id: eventId,
            session_id: sessionId
        });
        
        if (detectResponse.data.status && detectResponse.data.changes.length > 0) {
            console.log('Detected changes:', detectResponse.data.changes);
            
            // Apply the selective updates
            const updateResponse = await axios.post(`${baseUrl}/event_count/update-change`, {
                event_id: eventId,
                changes: detectResponse.data.changes,
                session_id: sessionId
            });

            console.log("update response:", updateResponse.data)
            
            if (updateResponse.data.status) {
                // Refresh only the affected data
                await refreshAffectedData(detectResponse.data.changes);

                await fetchData();
                setHasChanges(false);
                
                // Show success message
                toast.success('Raw material data updated successfully!');
            }
        } else {
            console.log('No menu changes detected');
            setHasChanges(false);
        }
        
    } catch (error) {
        console.error('Error updating menu changes:', error);
        toast.error('Failed to update raw material data');
    } finally {
      setLoading(false);
        setIsUpdating(false);
    }
};

// Function to refresh only affected data instead of full page reload
const refreshAffectedData = async (changes) => {
    try {
        // Get the current transformed data
        const currentData = [...transformedData];
        
        // Process each change
        for (const change of changes) {
            const { type, menu_item_id, old_menu_item_id } = change;
            
            switch (type) {
                case 'ADDED':
                    // Add new item data
                    await addNewMenuItemData(menu_item_id, currentData);
                    break;
                    
                case 'REMOVED':
                    // Remove item data
                    const updatedData = currentData.filter(item => 
                        item.menu_item_id !== menu_item_id
                    );
                    setTransformedData(updatedData);
                    break;
                    
                case 'UPDATED':
                    // Update existing item data
                    await updateExistingMenuItemData(old_menu_item_id, menu_item_id, currentData);
                    break;
            }
        }
        
    } catch (error) {
        console.error('Error refreshing affected data:', error);
        // Fallback to full refresh if selective refresh fails
        window.location.reload();
    }
};

// Add new menu item data
const addNewMenuItemData = async (menu_item_id, currentData) => {
    try {
        const sessionId = session[0]?.value;
        
        // Find the menu item details
        const menuItem = aggregatedMealList.find(item => item.menu_item_id === menu_item_id);
        if (!menuItem) return;
        
        // Fetch the raw material summary for this new item
        console.log("Menu item id", menu_item_id, "from date", fromDate, "to date", toDate, "session ", sessionId);
        const summaryCondition = `menu_item_id='${menu_item_id}' AND from_date='${fromDate}' AND to_date='${toDate}' AND session_id='${sessionId}'`;
        const summaryRes = await axios.get(`${baseUrl}/comman/list?table=raw_material_summary&condition=${summaryCondition}`);
        
        const apiDetail = summaryRes.data?.data?.[0];
        if (apiDetail) {
            const result = await getTableDetailDispaly(apiDetail, menu_item_id, menuItem, currentData.length, aggregatedMealList, false);
            if (result) {
                setTransformedData([...currentData, result]);
            }
        }
        
    } catch (error) {
        console.error('Error adding new menu item data:', error);
    }
};

// Update existing menu item data
const updateExistingMenuItemData = async (old_menu_item_id, new_menu_item_id, currentData) => {
    try {
        const sessionId = session[0]?.value;
        
        // Find the updated menu item details
        const menuItem = aggregatedMealList.find(item => item.menu_item_id === new_menu_item_id);
        if (!menuItem) return;
        
        // Fetch updated raw material summary
        const summaryCondition = `menu_item_id='${new_menu_item_id}' AND from_date='${fromDate}' AND to_date='${toDate}' AND session_id='${sessionId}'`;
        const summaryRes = await axios.get(`${baseUrl}/comman/list?table=raw_material_summary&condition=${summaryCondition}`);
        
        const apiDetail = summaryRes.data?.data?.[0];
        if (apiDetail) {
            // Find the index of the item to update
            const itemIndex = currentData.findIndex(item => item.menu_item_id === old_menu_item_id);
            if (itemIndex !== -1) {
                const result = await getTableDetailDispaly(apiDetail, new_menu_item_id, menuItem, itemIndex, aggregatedMealList, false);
                if (result) {
                    const updatedData = [...currentData];
                    updatedData[itemIndex] = result;
                    setTransformedData(updatedData);
                }
            }
        }
        
    } catch (error) {
        console.error('Error updating menu item data:', error);
    }
};

  const handelRemarks = (e) => {
    e.preventDefault();
    const updatedArray = transformedData.map(obj => ({
      ...obj,
      remarks: e.target.value
    }));
    
    setTransformedData(updatedArray);
  }
  const editMeal = async () => {
    navigate(`/meal_master/edit/${btoa(mealItemArray[0].id)}`, { state: mealItemArray });
  }

  // console.log("transform data:",transformedData);

  return (
    <div className="p-4">
      {loading && <Loader/>}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Raw Material Estimation Screen (Event)
        </h1>
        {/*<div className="flex items-center gap-4">
          <a
            href="/raw_material_day/list"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
          >
            Day Wise
          </a>
        </div>*/}
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative  shadow-md sm:rounded-lg">
      <EventDateSessionFilter handleFilterChange={handelFilterChange} />
                  <div className="flex flex-col md:flex-row justify-between items-center mb-4">
  {/* Input aligned to the left side of the screen */}
  <div className="w-full md:w-auto">
    <input
      type="number"
      step="0.01"
      id="estimated_count"
      name="estimated_count"
      placeholder="Estimated Count"
      onBlur={(e) => handelAllEstimateCount(e)}
      onWheel={(e) => e.target.blur()}
      className="w-full md:w-auto px-2 py-1 border rounded-md bg-orange-50"
    />
  </div>
  <div className="w-full md:w-auto">
    <input
      type="text"
     
      id="remarks"
      name="remarks"
      placeholder="Remarks"
      onChange={(e) => handelRemarks(e)}
      value={transformedData?.[0]?.remarks ?? ""} 
      className="w-full md:w-auto px-2 py-1 border rounded-md bg-orange-50"
    />
  </div>

  {/* Buttons aligned to the right, wrapping below input on smaller screens */}
  <div className="mt-4 md:mt-0 flex flex-col md:flex-row md:space-x-2 w-full md:w-auto justify-end">
    {/* <button
      className="w-full md:w-auto px-4 py-2 bg-green-500 text-white rounded-md"
      onClick={checkAndUpdateMenuChanges}
    >
      Refresh
    </button> */}
    <a href="/reports/summary" target="_blank" className="w-full md:w-auto">
      <button className="w-full md:w-auto px-4 py-2 bg-blue-500 text-white rounded-md mb-2 md:mb-0">
        Check Ras
      </button>
    </a>
    <a onClick={() => editMeal()} target="_blank" className="w-full md:w-auto">
      <button className="w-full md:w-auto px-4 py-2 bg-blue-500 text-white rounded-md mb-2 md:mb-0">
        Add Meal Item
      </button>
    </a>
    <button
      className="w-full md:w-auto px-4 py-2 bg-green-500 text-white rounded-md"
      onClick={(e) => handleSaveAll(e)}
    >
      Save
    </button>
  </div>
</div>
        <div className="flex flex-col gap-2 mb-2">
          <p className="text-sm text-gray-700">
            જો ઇવેન્ટના મેનૂ આઇટમમાં કઈ ફેરફાર થયેલ હોય તો ઇવેન્ટ અને સેશન પસંદ કર્યા પછી અહીં ક્લિક કરવું.
          </p>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200 self-start"
            onClick={checkAndUpdateMenuChanges}
          >
            Refresh
          </button>
        </div>

        <table className="border w-full">
          <thead>
              <tr>
                <th className="p-2">Meal Item Name</th>
                <th className="p-2"> Total Planned Count (Persons)</th>
                {/* <th className="p-2">Session Count</th> */}
                {/* <th className="p-2">Total Planned Count (Persons)</th> */}
                <th className="p-2">Std Ras Qty/100 Persons</th>
                <th className="p-2">Planned Ras Qty/100 Persons</th>
                <th className="p-2">Estimated RM Qty <span className="text-red-400">(Kgs.)</span></th>
                <th className="p-2">Planned RM Qty <span className="text-red-400">(Kgs.)</span></th>
                <th className="p-2">Estimated Production (Persons)</th>
                <th className="p-2" colSpan="2">FG Cmp./ Persons</th>
                <th></th>
              </tr>
          </thead>
          <tbody>
          {transformedData.map((item, index) => (
            <tr key={index}>
              <td className="p-2 text-center"><ItemNameStacked item={item} /></td>
              <td className="p-2 text-center">              
                <input type="number" 
                  step="1" 
                  id="estimated_count" 
                  name="estimated_count" 
                  value={Number(item?.estimated_count).toFixed(0)} 
                  onChange={handleInputChange(index)}
                  onBlur={(e) => handleCalculateAll(e, index)}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                  disabled={item.itemDisable}
                  className={`${validationAllErrors?.[index]?.estimated_count ? "border-red-500" : "border-gray-300"} 
                  px-2 py-1 border rounded-md w-full bg-orange-50`} 
                />
              </td>
              {/* <td className="p-2 text-center">{Number(item.sessionCount).toFixed(0)}</td> */}
              {/* <td className="p-2 text-center">{Number(item.totalPlannedCount).toFixed(0)}</td> */}
              <td className="p-2 text-center">
                <input type="number" 
                  step="0.01" 
                  id="std_ras_qty_per_100_person" 
                  name="std_ras_qty_per_100_person" 
                  value={Number(item.std_ras_qty_per_100_person).toFixed(2)} 
                  //disabled
                  className="px-2 py-1 border rounded-md w-full"
                />
              </td>
              <td className="p-2 text-center">
                <input
                  type="number"
                  step="0.01"
                  id="ras_qty_per_100_person"
                  name="ras_qty_per_100_person"
                  value={item?.ras_qty_per_100_person ?? ""}
                  onChange={handleInputChange(index)}
                  onBlur={(e) => handleCalculateAll(e, index)}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                  disabled={item.itemDisable}
                  className="px-2 py-1 border rounded-md w-full bg-orange-50"
                />
              </td>
              <td className="p-2 text-center">
                <input
                  type="number"
                  step="0.01"
                  id="estimated_rm_required"
                  disabled
                  value={Number(item?.estimated_rm_required).toFixed(0)}
                  className="px-2 py-1 border rounded-md w-full"
                />
              </td>
              <td className="p-2 text-center">
                <input
                  type="number"
                  step="1"
                  id="planned_rm_qty"
                  name="planned_rm_qty"
                  value={Number(item?.planned_rm_qty).toFixed(0)}
                  onChange={handleInputChange(index)}
                  onBlur={(e) => handleCalculateAll(e, index)}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                  disabled={item.itemDisable}
                  className={`${validationAllErrors?.[index]?.planned_rm_qty
                      ? "border-red-500"
                      : "border-gray-300"
                    } px-2 py-1 border rounded-md w-full bg-lime-300`}
                />
              </td>
              <td className="p-2 text-center">
                <input
                  type="number"
                  step="1"
                  id="estimated_production"
                  disabled
                  name="estimated_production"
                  value={Number(item?.estimated_production).toFixed(0)}
                  className={`${validationAllErrors?.[index]?.estimated_production
                      ? "border-red-500"
                      : "border-gray-300"
                    } px-2 py-1 border rounded-md w-full`}
                />
              </td>
              <td className="p-2 text-center">
                <input
                  type="number"
                  step="0.01"
                  name="fg_consumption_per_person"
                  disabled
                  id="fg_consumption_per_person"
                  value={Number(item?.fg_consumption_per_person).toFixed(2)}
                  className="px-2 py-1 border rounded-md w-28"
                />
              </td>
              <td>{item.unit}</td>
            </tr>
          ))}
          </tbody>
        </table>      
  
      </div>
    </div>
    
  );
}

export default RawMaterialEstimation;




